module.exports = __webpack_public_path__ + "../public/img/garrafa.0fc4fdee.png";